export const COMPLETE_DATE_LENGTH = 10;

export const DATE_FORMAT = 'MM/dd/yyyy';
